import { Edit } from "@mui/icons-material";
import {
  AlertColor,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { Profile } from "src/api/types";
import WhiteCard from "src/components/WhiteCard";
import { formatPhoneNumber } from "src/utils/formatPhoneNumber";
import { useManageModal } from "src/hooks/useManageModal";
import UpdatePasswordModal from "src/components/Modals/UpdatePasswordModal";
import TimedAlert from "src/shared/TimedAlert";
import { useCallback, useState } from "react";

interface Props {
  user: Profile;
  includePassword?: boolean;
}

const UserInfo = ({ user, includePassword = false }: Props) => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const [alert, setAlert] = useState<{
    text: string;
    severity: AlertColor;
  } | null>(null);

  const handleSuccess = useCallback(() => {
    handleClose();
    setAlert({ text: "Password successfully updated", severity: "success" });
  }, [handleClose]);

  return (
    <>
      <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
        <Typography variant="subtitle2">USER INFORMATION</Typography>
        <Typography>{`Email: ${user.email}`}</Typography>
        {includePassword ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography>{`Password: *****************`}</Typography>
            <Tooltip title="Update">
              <IconButton color="secondary" onClick={handleOpen}>
                <Edit />
              </IconButton>
            </Tooltip>
            {alert ? <TimedAlert alert={alert} setAlert={setAlert} /> : null}
          </Stack>
        ) : null}
        <Typography>{`Phone number: ${formatPhoneNumber(
          user.phone_number ?? "",
        )}`}</Typography>
        <Typography>{`Birth date: ${user.dob}`}</Typography>
        <Typography>{`Gender: ${user.gender}`}</Typography>
      </WhiteCard>
      <UpdatePasswordModal
        open={open}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default UserInfo;
